import Documents from "./sub-components/Documents";
import Information from "./sub-components/Information";
import Validation from "./sub-components/Validation";

function GuarantorInfo({ data, setUserInfo, allData, reGetData }) {
  return (
    <div>
      <div className="w-11/12 mx-auto flex items-center justify-between my-4">
        <h3 class="text-lg font-medium leading-none text-gray-900 dark:text-white">
          اطلاعات ضامن - {data?.name || ""}
        </h3>
        <button
          onClick={() => setUserInfo(null)}
          type="submit"
          class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          بازگشت
        </button>
      </div>
      <Information data={data} allData={allData} reGetData={reGetData} />
      <Validation data={data} allData={allData} reGetData={reGetData} />
      <Documents data={data} allData={allData} reGetData={reGetData} />
    </div>
  );
}

export default GuarantorInfo;
